import { createFileRoute } from "@tanstack/react-router";
import { createContext, useState } from "react";
import { AvaRuntimeProvider } from "@/lib/assistant-ui/ava-runtime.tsx";
import { AvaChat } from "@/components/ava/ava-chat.tsx";

// Debug mode context - shared between runtime and chat
export const DebugContext = createContext({
  isDebugMode: false,
  toggleDebug: () => {},
});

export const Route = createFileRoute("/_authenticated/ava/$chatId")({
  component: AvaChatPage,
});

function AvaChatPage() {
  const { chatId } = Route.useParams();
  const [isDebugMode, setIsDebugMode] = useState(false);

  const toggleDebug = () => {
    setIsDebugMode(!isDebugMode);
  };

  return (
    <DebugContext.Provider value={{ isDebugMode, toggleDebug }}>
      <AvaRuntimeProvider chatId={chatId}>
        <AvaChat chatId={chatId} />
      </AvaRuntimeProvider>
    </DebugContext.Provider>
  );
}
